'use client'

import { FormEvent, useState } from 'react'

import { useRouter, useSearchParams } from 'next/navigation'

import Button from '@components/buttons/button'
import Input from '@components/inputs/input'
import { queryString } from '@lib/helpers/client'

import styles from './search.module.scss'

export default function Search(): JSX.Element {
  const router = useRouter()
  const query = useSearchParams()
  const [searchKey, setSearchKey] = useState<string>(query?.get('query') || '')

  const submit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault()

    if (searchKey !== '') {
      router.push(`?${queryString({ category: undefined, page: '1', query: searchKey }, query?.toString())}`)
    }
  }

  return (
    <form className={styles.form} onSubmit={submit}>
      <h3>Search</h3>
      <Input placeholder="Search" value={searchKey} onChange={(e): void => setSearchKey(e.target.value)} />
      <Button variant="blue">Search</Button>
    </form>
  )
}
